import { render } from "./PointDesReglementsPage.vue?vue&type=template&id=653be37e&ts=true"
import script from "./PointDesReglementsPage.vue?vue&type=script&lang=ts"
export * from "./PointDesReglementsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__